module.exports = __webpack_public_path__ + "static/media/donbosco12.ad76c8b1.jpg";